import {useCallback, useEffect, useMemo, useRef, useState} from 'react';
import debounce from 'lodash-es/debounce';
import {fetchApi} from '../services/HTTP';

const useHokEditedPricePerSession = (props) => {
    const {price, daysOfWeek, editedValue, fieldPath, setFieldValue, enabled} = props;
    const [calculatedPricePerSession, setCalculatedPricePerSession] = useState(null);
    const pricePerSessionInitialized = useRef(false);
    const previousPricePerSessionInputs = useRef({price: null, daysOfWeek: null});

    const fetchPricePerSession = useCallback(debounce(async (nextPrice, nextDaysOfWeek) => {
        if (!nextPrice || Number(nextPrice) <= 0 || !nextDaysOfWeek) {
            setCalculatedPricePerSession(null);
            return;
        }
        try {
            const res = await fetchApi('hugim/calcPricePerSession', 'POST', {
                price: Number(nextPrice),
                days_of_week: nextDaysOfWeek,
            }, false, true);
            setCalculatedPricePerSession(res?.price_per_session ?? null);
        } catch (e) {
            setCalculatedPricePerSession(null);
        }
    }, 300), []);

    useEffect(() => {
        if (!enabled) {
            return;
        }
        const previousInputs = previousPricePerSessionInputs.current;
        const inputsChanged = previousInputs.price !== price || previousInputs.daysOfWeek !== daysOfWeek;
        // Only clear override after we already had a real price+days baseline (avoid wiping DB value while edit form settles)
        const shouldClearEdited = pricePerSessionInitialized.current
            && inputsChanged
            && previousInputs.price != null
            && previousInputs.daysOfWeek > 0
            && fieldPath;
        if (shouldClearEdited) {
            setFieldValue(fieldPath, null);
        }
        previousPricePerSessionInputs.current = {price, daysOfWeek};
        pricePerSessionInitialized.current = true;
        fetchPricePerSession(price, daysOfWeek);
        return () => fetchPricePerSession.cancel();
    }, [enabled, price, daysOfWeek, fieldPath, fetchPricePerSession, setFieldValue]);

    const displayedPricePerSession = useMemo(() => {
        if (editedValue !== null && editedValue !== undefined && editedValue !== '') {
            return editedValue;
        }
        return calculatedPricePerSession != null ? Math.round(calculatedPricePerSession * 100) / 100 : null;
    }, [editedValue, calculatedPricePerSession]);

    return {displayedPricePerSession};
};

export default useHokEditedPricePerSession;
